export default __webpack_public_path__ + "c755fa8152279bf69883e14898c985e5.png";